'use strict';

angular.module('formonlineApp').service('DelaiFiduService', ['$http',
    function ($http) {

        this.create = function (delaiFiduciaire, file) {
            return $http({
                method: 'post',
                url: 'api/delaifiduciaire',
                headers: {'Content-Type': undefined },
                transformRequest: function () {
                    var formData = new FormData();

                    formData.append('form', new Blob([angular.toJson(delaiFiduciaire)], {
                        type: 'application/json'
                    }));
                    formData.append('file', file);
                    return formData;
                },
                data: { data: delaiFiduciaire, file: file }
            });
        };

        this.check = function (delaiFiduciaire, file) {
            return $http({
                method: 'post',
                url: 'api/delaifiduciaire/check',
                headers: {'Content-Type': undefined },
                transformRequest: function () {
                    var formData = new FormData();

                    formData.append('form', new Blob([angular.toJson(delaiFiduciaire)], {
                        type: 'application/json'
                    }));
                    formData.append('file', file);
                    return formData;
                },
                data: { data: delaiFiduciaire, file: file }
            });
        };

    }]);
